import React from "react";
import { ActionList } from "./../../mood-ui/DataTable";

const TilloOfferListActions = ({ onClearSelection, onDelete }) => (
  <ActionList onClearSelection={onClearSelection}>
  </ActionList>
);

export default TilloOfferListActions;
